import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getPurchaseOrderListEffectCancelToken = () => {};
export const getPurchaseOrderListEffect = (data) => {
  getPurchaseOrderListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PO}/GetPurchaseOrder`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getPurchaseOrderListEffectCancelToken = c;
    }),
  });
};

export const getVendorList = (params) => {
  return axiosInstance.request({
    url: `${API.PO}/GetPoVendor`,
    method: 'get',
    params,
  });
};

export const getPoStatus = () => {
  return axiosInstance.request({
    url: `${API.PO}/GetPoStatus`,
    method: 'get',
  });
};

let getPurchaseOrderInfoEffectCancelToken = () => {};
export const getPurchaseOrderInfoEffect = (data) => {
  getPurchaseOrderInfoEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PO}/GetPoItem`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getPurchaseOrderInfoEffectCancelToken = c;
    }),
  });
};

let getFooterValuesCancelToken = () => {};
export const getPoFooterValues = (data) => {
  getFooterValuesCancelToken();
  return axiosInstance.request({
    url: `${API.PO}/GetFooterContent`,
    method: 'post',
    data: data,
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getFooterValuesCancelToken = c;
    }),
  });
};

export const getTotalPurchaseOrder = (data) => {
  return axiosInstance.request({
    url: `${API.PO}/GetTotalPurchaseOrder`,
    method: 'post',
    data: data,
  });
};

export const getTotalPurchaseOrderForExport = (data) => {
  return axiosInstance.request({
    url: `${API.PO}/GetPurchaseOrderForExport`,
    method: 'post',
    data: data,
  });
};

export const getIncoCodeByCustomer = ({ customerKey }) => {
  return axiosInstance.request({
    url: `${API.PO}/GetIncoCodeByCustomer`,
    method: 'get',
    params: {
      customerKey,
    },
  });
};
